import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader, Table } from "reactstrap";
import { listGotton } from "../../../components/Header/Data3";
import moment from "moment";

const GottonDetails = ({ isOpen, closeModal, ad, type, user }) => {
  const [gottenDetails, setGottenDetails] = useState([]);

  const fetchGottonDetails = async () => {
    const Id = ad.Id;
    let formData = {
      Type: type,
    };
    const gottonDetails = await listGotton(Id, formData);
    setGottenDetails(gottonDetails);
  };

  useEffect(() => {
    if (isOpen) {
      fetchGottonDetails();
    }
  }, [ad, isOpen]);

  const convertUtcToIst = (utcTime) => {
    const timezone = user?.TimeZone.split(",")[0];
    const localTime = moment
      .utc(utcTime)
      .tz(timezone)
      .format("MMMM DD, YYYY hh:mm A");
    console.log(localTime, "localTime");
    return localTime;
  };

  console.log(gottenDetails, "gottenDetails");

  return (
    <Modal isOpen={isOpen} toggle={closeModal} size="xl">
      <ModalHeader toggle={closeModal}>
        Customers {type === "within" ? "Gotten With-in " : "  Got After"}24
        hours
      </ModalHeader>
      <ModalBody>
        {gottenDetails?.length > 0 ? (
          <Table responsive className="table-light border">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Need Title</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {gottenDetails.map((details, i) => (
                <tr key={i}>
                  <td>{`${details.firstName} ${details.lastName}`}</td>
                  <td>{details.Email}</td>
                  <td>{`${details.countryCode} ${details.Phone}`}</td>
                  <td>{details.Title}</td>
                  <td>{convertUtcToIst(details.createdAt)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <div className="text-center my-3">No Gotten Records</div>
        )}
      </ModalBody>
    </Modal>
  );
};

export default GottonDetails;
